<script setup>
import { ref } from 'vue'
import { setup } from './login-form'
import resetMailSendModal from '../modal/resetMailSendModal.vue'
import PwSettingDoneModal from '../modal/PwSettingDoneModal.vue'
import PwResetDoneModal from '../modal/PwResetDoneModal.vue'

const props = defineProps({
  inputCompanyEmail: {
    type: String,
    required: true,
  },
  inputCompanyPw: {
    type: String,
    required: true,
  },
  actionUrl: {
    type: String,
    required: true,
  },
  pwResetUrl: {
    type: String,
    required: true,
  },
  csrfToken: {
    type: String,
    required: true,
  },
  pp: {
    type: String,
    required: true,
  },
  mailResult: {
    type: Boolean,
    required: false,
    default: false,
  },
  resetDone: {
    type: Boolean,
    required: false,
    default: false,
  },
  settingDone: {
    type: Boolean,
    required: false,
    default: false,
  },
})
const refForm = ref()
const {
  companyEmail,
  companyPw,
  companyEMAILErrorMessage,
  companyPWErrorMessage,
  violationForm,
  refPwResetDoneModal,
  refPwSettingDoneModal,
  refResetMailSendModal,
  formSubmit,
  checkCompanyEMAILLength,
  checkCompanyPWLength,
} = setup(props, refForm)
</script>

<template>
  <Teleport to="body #modal">
    <resetMailSendModal
      ref="refResetMailSendModal"
      :mailResult="mailResult"
    ></resetMailSendModal>

    <PwResetDoneModal
      ref="refPwResetDoneModal"
      :resetDone="resetDone"
    ></PwResetDoneModal>

    <PwSettingDoneModal
      ref="refPwSettingDoneModal"
      :settingDone="settingDone"
    ></PwSettingDoneModal>
  </Teleport>

  <form
    method="post"
    name="frm"
    :action="actionUrl"
    class="loginForm"
    accept-charset="utf-8"
    ref="refForm"
  >
    <input
      type="hidden"
      name="_token"
      :value="csrfToken"
    />
    <input
      type="hidden"
      name="_pp_"
      :value="pp"
    />
    <input
      id="company_email"
      type="email"
      style="ime-mode: disabled"
      placeholder="メールアドレス"
      class="form--line"
      name="company_email"
      v-model="companyEmail"
      v-on:blur="checkCompanyEMAILLength"
      v-bind:class="{
        md_error: companyEMAILErrorMessage.length > 0,
      }"
    />
    <template v-if="companyEMAILErrorMessage.length > 0">
      <p
        v-for="(message, index) in companyEMAILErrorMessage"
        class="errorMessage"
        :key="index"
      >
        <span class="iconImgPart">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 150 1100 1100"
          >
            <path
              d="m993.554 865.69-.267-.267-364.968-609.718c0-.267-.267-.267-.267-.544-23.986-38.818-65.23-61.994-110.515-61.994s-86.524 23.182-110.246 61.727c-.267.267-.544.544-.544 1.078L41.509 865.69s0 .267-.267.267c-11.321 19.409-17.52 42.051-17.52 64.96 0 70.622 57.416 128.574 127.767 129.382h731.833c70.622-.811 128.036-58.76 128.036-129.382 0-22.909-6.199-45.551-17.787-65.23zM882.5 974.05H152.564c-23.453-.267-42.318-19.676-42.318-43.129 0-7.544 1.889-14.821 5.66-21.298l364.968-609.448.267-.267c8.088-12.665 21.564-20.22 36.661-20.22s28.841 7.821 36.929 20.753L919.159 909.35c3.777 6.466 5.66 14.021 5.66 21.564.267 23.453-18.865 42.86-42.318 43.129zM517.53 456.516c-23.72 0-43.129 19.409-43.129 43.129v172.51c0 23.72 19.409 43.129 43.129 43.129s43.129-19.409 43.129-43.129v-172.51c0-23.72-19.409-43.129-43.129-43.129zm0 345.023c-11.321 0-22.375 4.577-30.461 12.665s-12.665 19.142-12.665 30.461 4.577 22.375 12.665 30.461c8.088 8.088 19.142 12.665 30.461 12.665s22.375-4.577 30.461-12.665c8.088-8.088 12.665-19.142 12.665-30.461s-4.577-22.375-12.665-30.461c-8.088-8.088-19.142-12.665-30.461-12.665z"
              fill="#f04438"
            ></path>
          </svg> </span
        >{{ message }}
      </p>
    </template>
    <input
      id="company_password"
      style="ime-mode: disabled"
      placeholder="パスワード"
      class="form--line"
      name="company_password"
      v-model="companyPw"
      type="password"
      v-on:blur="checkCompanyPWLength"
      v-bind:class="{
        md_error: companyPWErrorMessage.length > 0,
      }"
    />
    <template v-if="companyPWErrorMessage.length > 0">
      <p
        v-for="(message, index) in companyPWErrorMessage"
        class="errorMessage"
        :key="index"
      >
        <span class="iconImgPart">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 150 1100 1100"
          >
            <path
              d="m993.554 865.69-.267-.267-364.968-609.718c0-.267-.267-.267-.267-.544-23.986-38.818-65.23-61.994-110.515-61.994s-86.524 23.182-110.246 61.727c-.267.267-.544.544-.544 1.078L41.509 865.69s0 .267-.267.267c-11.321 19.409-17.52 42.051-17.52 64.96 0 70.622 57.416 128.574 127.767 129.382h731.833c70.622-.811 128.036-58.76 128.036-129.382 0-22.909-6.199-45.551-17.787-65.23zM882.5 974.05H152.564c-23.453-.267-42.318-19.676-42.318-43.129 0-7.544 1.889-14.821 5.66-21.298l364.968-609.448.267-.267c8.088-12.665 21.564-20.22 36.661-20.22s28.841 7.821 36.929 20.753L919.159 909.35c3.777 6.466 5.66 14.021 5.66 21.564.267 23.453-18.865 42.86-42.318 43.129zM517.53 456.516c-23.72 0-43.129 19.409-43.129 43.129v172.51c0 23.72 19.409 43.129 43.129 43.129s43.129-19.409 43.129-43.129v-172.51c0-23.72-19.409-43.129-43.129-43.129zm0 345.023c-11.321 0-22.375 4.577-30.461 12.665s-12.665 19.142-12.665 30.461 4.577 22.375 12.665 30.461c8.088 8.088 19.142 12.665 30.461 12.665s22.375-4.577 30.461-12.665c8.088-8.088 12.665-19.142 12.665-30.461s-4.577-22.375-12.665-30.461c-8.088-8.088-19.142-12.665-30.461-12.665z"
              fill="#f04438"
            ></path>
          </svg> </span
        >{{ message }}
      </p>
    </template>
  </form>
  <a
    v-if="violationForm"
    href="javascript:void(0);"
    class="md_btn md_btn--disable"
    >ログイン</a
  >
  <a
    v-else
    href="javascript:void(0);"
    class="md_btn"
    v-on:click="formSubmit"
    >ログイン</a
  >
  <a
    :href="pwResetUrl"
    class="md_textLink"
    >パスワードを忘れた方</a
  >
</template>
